module.exports = __webpack_public_path__ + "media/images/plus-blue-346c988fa0bae937839eea1c46c1cc6b.svg";